export const isCNMode = (locale: string) => locale === 'zh-CN';

export const setLocale = (lang) => {
  window.location.search = `?lang=${lang}`;
};

// 判断是否为移动端
export const isMobile = () => {
  return !!(
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  );
};

/**
 * 延迟 t 豪秒后执行某个函数
 * 用法：delay(3000).then(() => console.log('Hello'))
 * @param t
 */
export const delay = (t) => new Promise((resolve) => setTimeout(resolve, t));
